/*  window.addEventListener('load', function () {
    const loader = document.querySelector('.loader');




    loader.className += ' hidden';
  }); */
  
  window.addEventListener('load', function () {
    const loader = document.querySelector('.loader');

    setTimeout(function() {
      loader.className += ' hidden';
    }, 2500);
    
  });


/*   document.addEventListener("DOMContentLoaded", function(){
    const loader = document.querySelector('.loader');
    loader.className += ' hidden';
  });
 */


 